import React from 'react';
import { ChartColumnIcon, ChartPieIcon, HashIcon, PercentIcon, TriangleIcon, VariableIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';
const ICONS = {
  hash: HashIcon,
  pie: ChartPieIcon,
  variable: VariableIcon,
  percent: PercentIcon,
  triangle: TriangleIcon,
  chart: ChartColumnIcon
};

/* Colores de cada tomo, igual que en la portada del pack */
const TOMO_COLORS = ['bg-brand-blue', 'bg-emerald-600', 'bg-orange-600', 'bg-violet-600', 'bg-pink-600', 'bg-sky-600'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-brand-navy" data-id="element-163" data-mp="5vb06aewakbn">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-164" data-mp="5w2wjngbgm2z">
        <p className="font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-brand-yellow" data-id="element-165" data-mp="ktd7mvp1rpy6">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-1.5 font-display text-base font-extrabold leading-tight text-white sm:text-xl" data-id="element-166" data-mp="36bdyity7opsn">
          6 tomos en un solo sistema, creados para acompañar Matemática de 1.º
          año.
        </h2>
        <p className="mt-1 font-display text-[0.75rem] font-black uppercase leading-tight text-brand-yellow sm:text-sm" data-id="element-167" data-mp="3fdn6bc23i52c">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.78rem] leading-snug text-white/80" data-id="element-168" data-mp="3p8ovg7wdf74x">
          No es simplemente otro material con ejercicios. Es una ruta organizada
          que reúne contenidos, explicaciones, actividades y recursos para
          ayudarte a saber qué trabajar primero, cómo continuar y cómo
          relacionar los principales temas del año.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-169" data-mp="bvd39uwn12c6">
          {tomos.map((tomo, i) => {
          const Icon = ICONS[tomo.icon];
          return <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-lg bg-white text-left text-brand-navy" data-id="element-170" data-mp="grbvxup016ie" data-mpi={i}>
                <span className={`flex w-12 flex-shrink-0 flex-col items-center justify-center gap-1 text-white ${TOMO_COLORS[i]}`} data-id="element-171" data-mp="2mn4lq9iqlyt9">
                  <span className="font-display text-[0.5rem] font-bold uppercase tracking-wider" data-id="element-172" data-mp="2hu307io0z10p">
                    Tomo
                  </span>
                  <span className="font-display text-2xl font-black leading-none" data-id="element-173" data-mp="2rknyt63p85jm">
                    {i + 1}
                  </span>
                  <Icon size={13} aria-hidden="true" data-id="element-174" data-mp="35je4vb8hxfk4" />
                </span>
                <div className="p-2.5" data-id="element-175" data-mp="30mx6lo7l1ktb">
                  <h3 className="sr-only" data-id="element-176" data-mp="1b7fwfbi0gnpa">Tomo {i + 1}</h3>
                  <p className="font-display text-[0.78rem] font-extrabold uppercase leading-tight" data-id="element-177" data-mp="1b7zdyr3r1a2s">
                    {tomo.title}
                  </p>
                  <p className="mt-0.5 text-[0.74rem] leading-snug text-slate-700" data-id="element-178" data-mp="3hv6gj5a8omyo">
                    {tomo.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-3" data-id="element-179" data-mp="386ohotlispxo">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}